import { takeLatest, put, call, select, race, delay, take } from 'redux-saga/effects';
import jwt from 'jwt-decode';
import Cookies from 'js-cookie';
import { REFRESH_TOKEN_REQUEST, refreshTokenSuccess, refreshTokenFailure } from '../actions/refresh';
import { setTokens } from '../actions/token';
import { getAccessToken, getRefreshToken } from '../selectors/token';
import { refreshTokenService } from '../services/refresh';
import { SIGN_OUT } from '../actions/signout';
import { generateDuration, getDomain } from '../helpers';

const refreshTokenWorker = function* () {
    try {
        while (true) {

            const accessToken = yield select(getAccessToken);
            const refreshToken = yield select(getRefreshToken);

            if (refreshToken) {
                const { exp } = jwt(accessToken);

                const tokenRemainingMs = (exp * 1000) - Date.now();
                // Refresh 10% antes de que expire, con mínimo de 5s y máximo de 1h de anticipación
                const bufferMs = Math.min(3_600_000, Math.max(5_000, tokenRemainingMs * 0.1));
                const waitingTimeForTokenExpiration = Math.max(0, tokenRemainingMs - bufferMs);

                const { expiration } = yield race({
                    expiration: delay(waitingTimeForTokenExpiration),
                    logout: take(SIGN_OUT)
                });

                if (expiration) {
                    const {
                        data: {
                            access: newAccessToken,
                            refresh: newRefreshToken,
                        },
                    } = yield call(refreshTokenService, refreshToken);

                    yield put(refreshTokenSuccess());

                    yield put(setTokens(newAccessToken, newRefreshToken));

                    // Actualizar el cookie para que omuni-web tenga los tokens frescos
                    // y no haya desync entre las dos apps.
                    try {
                        const existing = Cookies.get('session', { domain: getDomain() });
                        const session = existing ? JSON.parse(existing) : {};
                        Cookies.set(
                            'session',
                            JSON.stringify({ ...session, accessToken: newAccessToken, refreshToken: newRefreshToken }),
                            { expires: generateDuration(), domain: getDomain() }
                        );
                    } catch { /* no bloquear el flujo si el cookie falla */ }
                } else {
                    throw new Error();
                }
            } else {
                throw new Error();
            }
        }
    } catch (err) {
        console.log(err);
        yield put(refreshTokenFailure());
    }
};

export default [takeLatest(REFRESH_TOKEN_REQUEST, refreshTokenWorker)];
